import React from 'react';
import css from './BasicButton.module.css';
import classNames from 'classnames';
import {
    CircleLoader,
    CircleLoaderProps,
} from '@shared/Ui/Loaders/CircleLoader/CircleLoader';

export interface BasicButtonProps
    extends React.ButtonHTMLAttributes<HTMLButtonElement>,
        CircleLoaderProps {
    extraClassName?: string;
    isReversed?: boolean;
    isLoading?: boolean;
}

const BasicButton: React.FC<BasicButtonProps> = ({
    children,
    onClick,
    extraClassName,
    isReversed,
    className = css.button,
    id,
    style,
    disabled,
    isLoading,
    loaderColor = 'var(--button-primary-text)',
    loaderSize = 25,
    loaderSpeed = 1.2,
    ...rest
}) => {
    return (
        <button
            type="button"
            className={classNames(className, extraClassName, {
                [css.buttonLoading]: isLoading,
                [css.reversed]: isReversed,
            })}
            onClick={onClick}
            id={id}
            style={style}
            disabled={disabled}
            {...rest}
        >
            {isLoading ? (
                <CircleLoader
                    loaderColor={loaderColor}
                    loaderSize={loaderSize}
                    loaderSpeed={loaderSpeed}
                />
            ) : (
                children
            )}
        </button>
    );
};

export default BasicButton;
